import {NotificationComponent} from "@ispm/dashboard/notification/component/notification.component";

export const SERVICES = [];
export const COMPONENTS = [NotificationComponent ];
export const COMPONENTS_EXPORTS = [NotificationComponent];